module.exports = "<li ng-bind-html=\"ctrl.prediction | highlightLocationPrediction\"></li>\n";


//////////////////
// WEBPACK FOOTER
// ./app/src/common/location_search/location_search_prediction.html
// module id = 309
// module chunks = 24